module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "access-menu"
    }
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Submission")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Submitted by")]), _c('br'), _vm._v("\n                        " + _vm._s(_vm.showSubmitter) + "\n                    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Lodged on")]), _c('br'), _vm._v("\n                        " + _vm._s(_vm._f("formatDate")(_vm.returns.lodgement_date)) + "\n                    ")]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Workflow")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                        " + _vm._s(_vm.returns.processing_status) + "\n                    ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAssignToList),
      expression: "showAssignToList"
    }],
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Assigned Officer")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [
    [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.returns.assigned_to),
        expression: "returns.assigned_to"
      }],
      ref: "assigned_to",
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.returns, "assigned_to", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.returns.activity_curators), function(member) {
      return _c('option', {
        key: member.id,
        domProps: {
          "value": member.id
        }
      }, [_vm._v(_vm._s(member.first_name) + " " + _vm._s(member.last_name))])
    }), 0), _vm._v(" "), _c('a', {
      staticClass: "actionBtn pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.assignToMe()
        }
      }
    }, [_vm._v("Assign to me")])]
  ], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAssignToList),
      expression: "!showAssignToList"
    }],
    staticClass: "col-sm-12 top-buffer-s"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showActionButtons),
      expression: "showActionButtons"
    }],
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Action")]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "255px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.acceptReturn()
      }
    }
  }, [_vm._v("Accept")]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "255px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.amendmentRequest()
      }
    }
  }, [_vm._v("Request Amendment")]), _vm._v(" "), _c('br'), _c('br')])])])])]), _vm._v(" "), _c('AmendmentRequest', {
    ref: "amendment_request"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('table', {
    staticClass: "table small-table"
  }, [_c('tr', [_c('th', [_vm._v("Lodgement")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a15e624"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/returns/access.vue
// module id = 956
// module chunks = 0